export default "__VITE_ASSET__0d3e05d1__"